import { useContext } from "react"
import { ThemeModeContext, type ThemeModeContextValue } from "./ThemeModeContext"

export const useThemeMode = (): ThemeModeContextValue => {
  const value = useContext(ThemeModeContext)

  if (!value) {
    throw new Error("useThemeMode must be used inside a ThemeModeProvider")
  }

  return value
}
